<template>
  <ElDialog
    :visible="value"
    :title="$t('ADVERTISEMENT.NEW_CAMPAIGN_SEARCH_ADS')"
    width="35%"
    @close="closeAndReset"
  >
    <AddSearchCampaignGeneral
      :reset-controller="resetController"
      :apps="apps"
      :campaigns="campaigns"
      @submit="submit"
    />
  </ElDialog>
</template>

<script>
import { SearchAdsCampaigns } from '@/api/api';
import createController from '@/utils/controller';
import AddSearchCampaignGeneral from './AddSearchCampaignGeneral';
import { campaignTypes } from '../../../common/constants';
import { AD_NEW_CAMPAIGN_CREATION_STATE, STATE } from '@/constants/gtm-events';
const resetController = createController('reset');

const INITIAL_CAMPAIGN_MODEL = {
  name: '',
  packageName: '',
  budget: 0,
  startDate: '',
  endDate: '',
  paused: false,
  hasTracker: false,
  impressionTrackerLink: null,
  cloneFrom: null,
};

export default {
  name: 'AddSearchCampaignModal',
  components: {
    AddSearchCampaignGeneral,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    apps: {
      type: Array,
      required: true,
    },
    campaigns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      campaignModel: { ...INITIAL_CAMPAIGN_MODEL },
    };
  },
  computed: {
    resetController() {
      return resetController;
    },
  },
  methods: {
    closeAndReset() {
      this.$emit('input', false);
      this.resetController.reset();

      this.campaignModel = {
        ...INITIAL_CAMPAIGN_MODEL,
      };
    },
    submit(data) {
      this.setData(data);
      this.addCampaign();
    },
    setData(data) {
      for (let prop in data) {
        if (prop in this.campaignModel) {
          this.campaignModel[prop] = data[prop];
        }
      }
    },
    addCampaign() {
      this.isLoading = true;

      return SearchAdsCampaigns.addCampaign(this.campaignModel)
        .then(message => {
          this.$gtm.trackEvent(AD_NEW_CAMPAIGN_CREATION_STATE(STATE.SUCCESS));
          this.$message.success(message);
          this.closeAndReset();
          this.$emit('add', campaignTypes.SEARCH);
        })
        .catch(({ message }) => {
          this.$gtm.trackEvent(AD_NEW_CAMPAIGN_CREATION_STATE(STATE.FAIL));

          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
